import React from "react";

export const AutocompleteFix = () => (
	<>
		<input
			type="text"
			autoComplete="new-password"
			style={{ display: "none" }}
		/>

		<input
			type="email"
			autoComplete="new-password"
			style={{ display: "none" }}
		/>
		<input
			type="number"
			autoComplete="new-password"
			style={{ display: "none" }}
		/>
		<input
			type="password"
			autoComplete="new-password"
			style={{ display: "none" }}
		/>
	</>
);
